// UserResetpass.jsx
import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../../config/config';
import styles from './UserResetpass.module.css';

const UserResetpass = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirm) {
      return setError('Passwords do not match');
    }

    try {
      const res = await axios.post(`${config.apiBaseUrl}/api/users/reset-password/${token}`, { password });
      setMessage(res.data.message);
      setTimeout(() => navigate('/shreeohm/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed');
    }
  };

 return (
  <div className={styles.container}>
    <h2 className={styles.title}>Reset Password</h2>
    <form onSubmit={handleReset} className={styles.form}>
      <input
        type="password"
        className={styles.input}
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <input
        type="password"
        className={styles.input}
        placeholder="Confirm Password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        required
      />
      <button type="submit" className={styles.button}>
        Reset Password
      </button>
    </form>
    {message && <p className={styles.message}>{message}</p>}
    {error && <p className={styles.error}>{error}</p>}
  </div>
);
};

export default UserResetpass;
